import { useEffect, useState } from 'react';

/** Names that rotate in the "Debate ___" headline. Length-matched (8–9 chars) so the layout stays stable. */
const NAMES = [
  'Aristotle',
  'Nietzsche',
  'Socrates',
  'Confucius',
  'Einstein',
  'Napoleon',
  'Cleopatra',
  'Galileo',
  'Machiavelli',
] as const;

const TYPE_MS = 95;
const DELETE_MS = 45;
const HOLD_MS = 1500;
const BETWEEN_MS = 320;
const INITIAL_DELAY_MS = 1400;

type Phase = 'typing' | 'holding' | 'deleting' | 'pausing';

export function Typewriter() {
  const [text, setText] = useState('');
  const [cursorActive, setCursorActive] = useState(false);

  useEffect(() => {
    let nameIndex = 0;
    let charIndex = 0;
    let phase: Phase = 'typing';
    let timer: number | undefined;

    const tick = () => {
      const current = NAMES[nameIndex];
      if (phase === 'typing') {
        setCursorActive(true);
        charIndex++;
        setText(current.slice(0, charIndex));
        if (charIndex >= current.length) {
          phase = 'holding';
          setCursorActive(false);
          timer = window.setTimeout(tick, HOLD_MS);
        } else {
          timer = window.setTimeout(tick, TYPE_MS);
        }
      } else if (phase === 'holding') {
        phase = 'deleting';
        timer = window.setTimeout(tick, 0);
      } else if (phase === 'deleting') {
        setCursorActive(true);
        charIndex--;
        setText(current.slice(0, charIndex));
        if (charIndex <= 0) {
          phase = 'pausing';
          setCursorActive(false);
          timer = window.setTimeout(tick, BETWEEN_MS);
        } else {
          timer = window.setTimeout(tick, DELETE_MS);
        }
      } else if (phase === 'pausing') {
        nameIndex = (nameIndex + 1) % NAMES.length;
        phase = 'typing';
        timer = window.setTimeout(tick, 0);
      }
    };

    timer = window.setTimeout(tick, INITIAL_DELAY_MS);
    return () => {
      if (timer !== undefined) clearTimeout(timer);
    };
  }, []);

  return (
    <span className="hero__rotator">
      <span className="hero__rotator-ghost" aria-hidden="true">
        {NAMES.map((name) => (
          <span key={name}>{name}</span>
        ))}
      </span>
      <span className="hero__rotator-active" aria-hidden="true">
        <span className="hero__rotator-text">{text}</span>
        <span className={`hero__rotator-cursor${cursorActive ? ' is-active' : ''}`} />
      </span>
    </span>
  );
}
